export const SET_BOOKINGLINEDETAILS = 'SET_BOOKINGLINEDETAILS';
export const FAILED_GET_BOOKINGLINEDETAILS = 'FAILED_GET_BOOKINGLINEDETAILS';
export const SUCCESS_CREATE_BOOKING_LINE_DETAIL = 'SUCCESS_CREATE_BOOKING_LINE_DETAIL';
export const FAILED_CREATE_BOOKING_LINE_DETAIL = 'FAILED_CREATE_BOOKING_LINE_DETAIL';
export const SUCCESS_UPDATE_BOOKING_LINE_DETAIL = 'SUCCESS_UPDATE_BOOKING_LINE_DETAIL';
export const FAILED_UPDATE_BOOKING_LINE_DETAIL = 'FAILED_UPDATE_BOOKING_LINE_DETAIL';
export const SUCCESS_DELETE_BOOKING_LINE_DETAIL = 'SUCCESS_DELETE_BOOKING_LINE_DETAIL';
export const FAILED_DELETE_BOOKING_LINE_DETAIL = 'FAILED_DELETE_BOOKING_LINE_DETAIL';
export const RESET_FLAG_LINEDETAILS = 'RESET_FLAG_LINEDETAILS';
export const SUCCESS_MOVE_LINE_DETAILS = 'SUCCESS_MOVE_LINE_DETAILS';
export const FAILED_MOVE_LINE_DETAILS = 'FAILED_MOVE_LINE_DETAILS';



// WEBPACK FOOTER //
// ./src/state/constants/bookingLineDetailConstants.js